import { render } from "./ClientsDetails.vue?vue&type=template&id=29d46c70&scoped=true"
import script from "./ClientsDetails.vue?vue&type=script&lang=js"
export * from "./ClientsDetails.vue?vue&type=script&lang=js"

import "./ClientsDetails.vue?vue&type=style&index=0&id=29d46c70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29d46c70"]])

export default __exports__